import "./MaterialCompatibilityGuide.module.css";
import Header from "@/reusable_sections/Header";
import PageBreadcrumb from "@/components/common/PageBreadcrumb";
import CompatibilityHero from "./sections/CompatibilityHero";
import Compatibility from "./sections/Compatibility";
import RelatedArticles from "./sections/RelatedArticles";
import QuoteBanner from "./sections/QuoteBanner";
import Footer from "@/reusable_sections/Footer";
export default function MaterialCompatibilityGuidePage() {
  return <div>
      <Header />
      <PageBreadcrumb page="MaterialCompatibilityGuide" />
      <CompatibilityHero />
      <Compatibility />
      <RelatedArticles />
      <QuoteBanner />
      <Footer />
    </div>;
}